module.exports = __webpack_public_path__ + "static/media/Check Blue.6bf85157.svg";